import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles(theme => ({
    container: {
        zIndex: 999,
        background: theme.palette.background.default,
        transition: '1000ms ease-out all',
        opacity: 1,
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        overflow: 'hidden',
    },

    done: {
        opacity: 0,
        visibility: 'hidden',
    },

    cubes: {
        width: '150px',
        height: '150px',
        margin: '100px auto',
        '& > *': {
            width: '33%',
            height: '33%',
            backgroundColor: theme.palette.primary.main,
            float: 'left',
            animation: '$cubeGridScaleDelay 1.3s infinite ease-in-out',
        }
    },

    cube1: {
        animationDelay: '0.2s',
    },
    cube2: {
        animationDelay: '0.3s',
    },
    cube3: {
        animationDelay: '0.4s',
    },
    cube4: {
        animationDelay: '0.1s',
    },
    cube5: {
        animationDelay: '0.2s',
    },
    cube6: {
        animationDelay: '0.3s',
    },
    cube7: {
        animationDelay: '0s',
    },
    cube8: {
        animationDelay: '0.1s',
    },
    cube9: {
        animationDelay: '0.2s',
    },

    '@keyframes cubeGridScaleDelay': {
        '0%, 70%, 100%': {
            transform: 'scale3D(1, 1, 1)',
        },
        '35%': {
            transform: 'scale3D(0, 0, 1)',
        },
    },
}));

export function Loader() {
    const styles = useStyles();
    return (
        <div className={styles.container}>
            <div className={styles.cubes}>
                <div className={styles.cube1}></div>
                <div className={styles.cube2}></div>
                <div className={styles.cube3}></div>
                <div className={styles.cube4}></div>
                <div className={styles.cube5}></div>
                <div className={styles.cube6}></div>
                <div className={styles.cube7}></div>
                <div className={styles.cube8}></div>
                <div className={styles.cube9}></div>
            </div>
        </div>
    );
}